import clsx from "clsx";
import { Key } from "react";

export default function Tablist<T>({
  className,
  ariaLabelledBy,
  currentTab,
  setCurrentTab,
  options,
}: {
  className?: string;
  ariaLabelledBy: string;
  currentTab: T;
  setCurrentTab: (value: T) => void;
  options: Array<{
    value: T;
    controls: string;
    text: string | undefined;
    disabled?: boolean;
    className?: string;
  }>;
}) {
  return (
    <div className={className} role="tablist" aria-labelledby={ariaLabelledBy}>
      {options.map((option) => (
        <button
          role="tab"
          className={clsx(className, "button", {
            "button--outline": currentTab !== option.value,
          })}
          aria-selected={currentTab === option.value}
          aria-controls="resultsByStatement"
          onClick={() => setCurrentTab(option.value)}
          disabled={option.disabled}
          key={option.value as Key}
        >
          {option.text}
        </button>
      ))}
    </div>
  );
}
